<script setup lang="ts">
import { DropdownMenuItem, useForwardPropsEmits } from 'radix-vue'
import type { DropdownMenuItemEmits, DropdownMenuItemProps } from 'radix-vue'

const props = defineProps<DropdownMenuItemProps>()
const emits = defineEmits<DropdownMenuItemEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <DropdownMenuItem :class="$style.item" v-bind="forwarded">
    <slot />
  </DropdownMenuItem>
</template>

<style lang="scss" module>
.item {
  padding: 16px;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background-color: $color-gray-100;
  }
}
</style>
